import styled from "styled-components";
import TextareaAutosize from "react-textarea-autosize";

export const StyledTextArea = styled(TextareaAutosize)``;
